import SvgImage from "./SvgImage"

export default SvgImage
